export const ASIDE_WIDTH = 256;
export const ASIDE_MIN_WIDTH = 80;
export const HEADER_HEIGHT = 72;
export const URL_PARAM_NAME = 'name';
export const ASIDE_ITEM_HEIGHT = 56;
